<template>
  <div>
    <v-tabs v-model="active" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'Employee'" :href="'#Employee'">{{ $t('Employee') }}</v-tab>
      <!-- <v-tab ripple :key="'Ictdevices'" :href="'#Ictdevices'">{{ $t('ICT Devices') }}</v-tab> -->
    </v-tabs>

    <div v-if="active == 'Employee'">
      <Employee></Employee>
    </div>
    <div v-if="active == 'Ictdevices'">
      <Ictdevices></Ictdevices>
    </div>
  </div>
</template>

<script>
import Employee from './Employee.vue'
import Ictdevices from './Ictdevices.vue'
export default {
  components: {
    Employee,
    Ictdevices
  },
  data() {
    return {
      active: 'Employee'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/pttlng/main.vue